var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-355.38V-720q0-39.15 22.5-62.96 22.5-23.81 60.96-36.46 38.46-12.66 89.42-16.62Q423.85-840 480-840q58.31 0 109.12 3.96 50.8 3.96 88.92 16.62 38.11 12.65 60.04 36.46Q760-759.15 760-720v364.62q0 48.23-33.58 81.8Q692.85-240 644.62-240l60 60v20h-33.85l-80-80H369.23l-80 80h-33.85v-20l60-60q-48.23 0-81.8-33.58Q200-307.15 200-355.38ZM480-800q-117.54 0-171.15 15.58-53.62 15.57-64.7 45.96h472.62q-10.39-30.85-64.12-46.19Q598.92-800 480-800ZM240-520h220v-178.46H240V-520Zm404.62 40H240h480-75.38ZM500-520h220v-178.46H500V-520ZM371.85-348.15q12.77-12.77 12.77-31.85 0-19.08-12.77-31.85-12.77-12.77-31.85-12.77-19.08 0-31.85 12.77-12.77 12.77-12.77 31.85 0 19.08 12.77 31.85 12.77 12.77 31.85 12.77 19.08 0 31.85-12.77Zm280 0q12.77-12.77 12.77-31.85 0-19.08-12.77-31.85-12.77-12.77-31.85-12.77-19.08 0-31.85 12.77-12.77 12.77-12.77 31.85 0 19.08 12.77 31.85 12.77 12.77 31.85 12.77 19.08 0 31.85-12.77ZM315.38-280h329.24Q676-280 698-302q22-22 22-53.38V-480H240v124.62Q240-324 262-302q22 22 53.38 22ZM480-738.46h236.77-472.62H480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.eb117db2d9f295182f014022aa8e5c69.svg";
export { ForwardRef as ReactComponent };